import type { iRoute } from "@rotorstudios/fe-modules";
import { ROUTES_DATA } from "./routesData";
import { PAGE_HOME, PAGE_NEXT_STEPS, PAGE_ERROR, PAGE_VEHICLE_SELECTION } from "./static";

// TODO fix fe-modules to export types properly
type iRoutes = typeof iRoute;
// The tree below is custom implementation using react-router-dom 5.x
// We are following react-router-dom 6.x API https://reactrouter.com/en/main/routers/create-browser-router
// as a guide for our custom solution

export const ROUTES_PAGES_MAIN_TREE: iRoutes[] = [
  // Vehicle Selection
  ROUTES_DATA.get(PAGE_VEHICLE_SELECTION),
  // Home
  ROUTES_DATA.get(PAGE_HOME),
  // Next Steps
  ROUTES_DATA.get(PAGE_NEXT_STEPS),
  // Error
  ROUTES_DATA.get(PAGE_ERROR),
];
